import {
  createBrowserRouter,
  Navigate,
  useRouteError,
  isRouteErrorResponse,
} from "react-router-dom";

import { AssinaturasAdminUsers } from "./assinaturas/components/AssinaturasAdminUsers";
import { AssinaturasCreate } from "./assinaturas/components/AssinaturasCreate";
import { AssinaturasDetail } from "./assinaturas/components/AssinaturasDetail";
import { AssinaturasLayout } from "./assinaturas/components/AssinaturasLayout";
import { AssinaturasList } from "./assinaturas/components/AssinaturasList";
import { AssinaturasLogin } from "./assinaturas/components/AssinaturasLogin";
import { AssinaturasResetPassword } from "./assinaturas/components/AssinaturasResetPassword";
import Layout from "./component";
import Home from "./home";
import Observer from "./observer";
import Sign from "./sign";
import SignSingle from "./sign-single";
import Validate from "./validate";
import ValidateEnvelope from "./validate-envelope";
import NotVerifiedDocument from "../components/not-verified-document.tsx";

export function RootBoundary(): JSX.Element {
  const error = useRouteError();
  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      return <NotVerifiedDocument />;
    }
    return <div>Error</div>;
  }

  return <div>Error</div>;
}

const router = createBrowserRouter([
  {
    errorElement: <RootBoundary />,
    children: [
      {
        path: "/assinaturas/login",
        element: <AssinaturasLogin />,
      },
      {
        path: "/assinaturas/reset-password",
        element: <AssinaturasResetPassword />,
      },
      {
        path: "/assinaturas",
        element: <AssinaturasLayout />,
        children: [
          {
            index: true,
            element: <AssinaturasList />,
          },
          {
            path: "create",
            element: <AssinaturasCreate />,
          },
          {
            path: "admin/users",
            element: <AssinaturasAdminUsers />,
          },
          {
            path: ":id",
            element: <AssinaturasDetail />,
          },
        ],
      },
      { Component: Layout, children: [Home, Validate, Observer, Sign, SignSingle, ValidateEnvelope] },
      {
        path: "*",
        element: <Navigate replace to="/" />,
      },
    ],
  },
]);

export default router;
